import React, { ReactNode } from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import SkipLink from '../skip-link';
import Logotext from '../logotext';
import Nav from './nav';
import { paths } from '../../routing';
import styles from './styles.module.scss';

interface PublicLayoutProps {
  children: ReactNode;
  mainContentClassName?: string;
  confirmationToken?: string;
}

const PublicLayout: React.FC<PublicLayoutProps> = ({ children, mainContentClassName = '', confirmationToken }) => (
  <div className={styles.root}>
    <SkipLink href="#public-content" />
    <Link to={paths.home} className={styles.logo} aria-label="Home">
      <Logotext isFull />
    </Link>
    <div className={styles.container}>
      {!confirmationToken ? <Nav /> : null}
      <main id="public-content" className={classNames(styles.main, mainContentClassName)}>
        {children}
      </main>
      <a href="/help" target="_blank" rel="noopener noreferrer" className={styles.supportLink}>
        Need help? Visit our Help Center
      </a>
    </div>
  </div>
);

export default PublicLayout;
